function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MutableSettings = function MutableSettings() {
  _classCallCheck(this, MutableSettings);

  this.reactive = true;
  this.themes = {};
  this.gtagId = null;
};

var settings = new MutableSettings();
export { settings };

var ImmutableSettings = /*#__PURE__*/function () {
  function ImmutableSettings() {
    _classCallCheck(this, ImmutableSettings);
  }

  _createClass(ImmutableSettings, null, [{
    key: "reactive",
    get: function get() {
      return settings.reactive;
    }
  }, {
    key: "themes",
    get: function get() {
      return settings.themes;
    }
  }, {
    key: "env",
    get: function get() {
      return process.env.NODE_ENV;
    }
  }, {
    key: "appVersion",
    get: function get() {
      return require("../package.json").version;
    } // static get build() {
    //   switch (this.env) {
    //     case 'development':
    //       return new DevBuild()
    //     default:
    //       return new ProdBuild()
    //   }
    // }

  }, {
    key: "assetCdn",
    get: function get() {
      return "".concat(this.build.assetDomain, "/").concat(this.appVersion);
    }
  }, {
    key: "apiHost",
    get: function get() {
      return this.build.apiDomain;
    }
  }, {
    key: "isDev",
    get: function get() {
      return this.env == "development";
    }
  }]);

  return ImmutableSettings;
}();

export { ImmutableSettings as default };